import { render, staticRenderFns } from "./GradeGroupItemForm.vue?vue&type=template&id=da5be53e"
import script from "./GradeGroupItemForm.vue?vue&type=script&lang=js"
export * from "./GradeGroupItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports